import { render, staticRenderFns } from "./uploadError.vue?vue&type=template&id=52753f7b"
import script from "./uploadError.vue?vue&type=script&lang=js"
export * from "./uploadError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports